export const MEDIA_VIEWER_SWIPE_THRESHOLD_PX = 48;

export function swipeDirection(
  deltaX,
  deltaY,
  threshold = MEDIA_VIEWER_SWIPE_THRESHOLD_PX,
) {
  if (!Number.isFinite(deltaX) || !Number.isFinite(deltaY)) return null;
  if (Math.abs(deltaX) < threshold) return null;
  if (Math.abs(deltaX) <= Math.abs(deltaY)) return null;
  return deltaX < 0 ? "next" : "prev";
}
